/* eslint-disable @typescript-eslint/no-unused-vars */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RebirthHttp, Path, PUT, Body, Query ,POST, BaseUrl} from 'rebirth-http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
@BaseUrl(environment.baseUrl)
export class DefaultCompanyService extends RebirthHttp {
  constructor(http: HttpClient) {
    super(http);
  }

  // @GET(
  //   environment.wso2amEndPoint +
  //     '/clm' +
  //     environment.wso2amApiVersion +
  //     '/api/v1/customers/user/getCompanyDetails/:loginId'
  // )
  // listCompanies(@Path('loginId') loginId: any): Observable<any> | any {
  //   return null;
  // }
  @POST(
    environment.wso2amEndPoint +
      '/clm' +
      environment.wso2amApiVersion +
      '/api/v1/registrations/search'
  )
  listCompanies(@Query('accountNo') accountNo :string ,@Body userObj?:any): Observable<any> | any {
    return null;
  }

  @POST(
    environment.wso2amEndPoint +
      '/clm' +
      environment.wso2amApiVersion +
      '/api/v1/registrations/search'
  )
  getClmTraders(
    @Body traderInfo: any
  ): Observable<any> | any {
    return null;
  }

  @POST(
    environment.wso2amEndPoint +
      '/clm' +
      environment.wso2amApiVersion +
      '/api/v1/registrations/brokers/search'
  )
  getClmAuthBroker(
    @Query('traderCode') traderCode?:any,
    @Body brokerInfo?: any,
  ): Observable<any> | any {
    return null;
  }

  @PUT(
    environment.wso2amEndPoint +
      '/clm' +
      environment.wso2amApiVersion +
      '/api/v1/customers/user/updateDefaultCompany/:loginId/:customerId'
  )
  setDefaultCompany(
    @Body obj: any,
    @Path('loginId') loginId: string,
    @Path('customerId') customerId: number
  ): Observable<any> | any {
    return null;
  }
}
